import React, { useEffect } from 'react';

import AppCloseLogo from '../../assets/icons/appcloseLogo.svg';
import { EMAIL_SUPPORT_URL } from '../../constants';
import * as styles from './styles.module.scss';

type SupportPopupProps = {
  open: boolean;
  onClose: () => void;
  onHelpCenter: () => void;
  onSupportForm: () => void;
};

const formatTimestamp = () =>
  new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date());

export const SupportPopup = ({
  open,
  onClose,
  onHelpCenter,
  onSupportForm,
}: SupportPopupProps) => {
  useEffect(() => {
    if (!open) return;

    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', onKey);

    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      id="support-popup"
      className={styles.popup}
      role="dialog"
      aria-modal="true"
      aria-labelledby="support-popup-title">
      <header className={styles.popupHeader}>
        <div className={styles.popupHeaderBrand}>
          <AppCloseLogo className={styles.popupLogo} aria-hidden="true" />
          <h2 id="support-popup-title" className={styles.popupTitle}>
            AppClose Support
          </h2>
        </div>
        <button
          type="button"
          className={styles.popupClose}
          aria-label="Close"
          onClick={onClose}
        />
      </header>

      <div className={styles.popupBody}>
        <p className={styles.popupTimestamp}>{formatTimestamp()}</p>
        <p className={styles.popupSender}>AppClose</p>

        <div className={styles.popupMessage}>
          <p>
            Thank you for contacting AppClose. Please submit your question through
            our support form{' '}
            <button
              type="button"
              className={styles.inlineLink}
              onClick={onSupportForm}>
              here
            </button>{' '}
            or email us at{' '}
            <a href={EMAIL_SUPPORT_URL}>support@appclose.com</a>, and a member
            of our team will respond as soon as possible.
          </p>
          <p>
            In the meantime, you may be able to find the answer you&apos;re
            looking for in our Help Center. Simply click &quot;Help Center&quot;
            and enter your question below to search articles, guides, and
            answers to common questions.
          </p>
        </div>

        <div className={styles.popupActions}>
          <button
            type="button"
            className={styles.actionButton}
            onClick={onHelpCenter}>
            Help Center
          </button>
          <button
            type="button"
            className={styles.actionButton}
            onClick={onSupportForm}>
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};
